export const MESSAGES = {
  LOGIN: "You are logged in",
  LOGOUT: "You are logged out",
  SESSION_EXPIRED: "Your session is expired",
};
